// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderDetailsPaymentInfoStyles } from "@turnerBlueprint/App/Widgets/OrderDetails/OrderDetailsPaymentInfo";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { css } from "styled-components";

orderDetailsPaymentInfoStyles.titleText = {
    size: 14,
    lineHeight: "16px",
    weight: fontConfig.weight.bold,
    css: css`
        display: block;
        margin-bottom: 8px;
    `,
};

orderDetailsPaymentInfoStyles.poTitle = {
    size: 14,
    lineHeight: "16px",
    weight: fontConfig.weight.bold,
    css: css`
        display: block;
        margin-bottom: 20px;
    `,
};

orderDetailsPaymentInfoStyles.infoWrapper = {
    css: css`
        display: flex;
        gap: 8px;
        margin-bottom: 20px;
    `,
};

orderDetailsPaymentInfoStyles.text = {
    size: 14,
    lineHeight: "22px",
};


orderDetailsPaymentInfoStyles.mainTitle = {
    variant: "h3",
};
